import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import SVG from 'components/widgets/icons/svg';


class PortalChangesMenuAlert extends React.Component {
  static propTypes = {
    currentUser: PropTypes.object
  };

  render() {
    const { currentUser } = this.props;

    if (currentUser.hasViewedLatestPortalChanges) return null;

    return <SVG className="new-portal-changes" src="svg/new.svg" />;
  }
}

export default connect((state) => ({
  currentUser: state.auth.currentUser
}))(PortalChangesMenuAlert);
